import { RouteRecordRaw } from 'vue-router';
import {
  INSWITCH_CALLBACK_ROUTE_NAME,
  INSWITCH_CALLBACK_ROUTE_PATH,
} from '@/shared/inswitch/constants/inswitch.constant';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const RechargeMoney = () => import('@/modules/cashIn/index.vue');
const NotifyPayment = () => import('@/modules/cashIn/views/NotifyPayment/index.vue');
const InswitchPaymentCallback = () => import('@/modules/cashIn/views/InswitchStatus/index.vue');

const cashInRoutes: Array<RouteRecordRaw> = [
  {
    path: '/recharge-money',
    name: 'recharge-money',
    redirect: {
      name: 'recharge-index',
    },
    meta: {
      accessRol: {
        section: 'WALLET',
        actions: ['ADD_FOUNDS'],
      },
    },

    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'recharge-index',
        component: RechargeMoney,
      },
    ],
  },
  {
    path: '/notify-payment/:transferId',
    name: 'notify-payment',
    component: NotifyPayment,
    meta: {
      layout: 'onboarding',
      accessRol: {
        section: 'WALLET',
        actions: ['ADD_FOUNDS'],
      },
    },
  },
  {
    path: INSWITCH_CALLBACK_ROUTE_PATH,
    name: INSWITCH_CALLBACK_ROUTE_NAME,
    component: InswitchPaymentCallback,
    meta: {
      isPaymentCallback: true,
    },
  },
];

export default cashInRoutes;
